/* eslint-disable */
import React, { useEffect, useMemo, useState } from 'react';
import InputFieldComponent from '../common/FormComponents/InputFieldComponent';
import { Field } from 'formik';
import { IoMdArrowDropdown } from "react-icons/io";
import getPpeKit from '../ppe/queries/getPpeKit';
import showAlert from '../../utils/alert';
import DropdownFieldComponent from '../common/FormComponents/DropdownFieldComponent';
import getAllPpeComponent from '../ppe/queries/getAllPpeComponent';
import AdhocItemTable from './AdhocItemTable';

const AdhocItemForm = ({ id, setFieldValue, expenseCategoryList, index, crew, values, errors, touched,restoredPpeCategoryDetails }) => {
  const [ppeListFinal, setppeListFinal] = useState([]);
  const [show, setShow] = useState(false);
  const oldCrew = useMemo(() => crew?.crewCode, []);
  const [columns, setColumns] = useState([]);
  const [newItem, setNewItem] = useState({ item: '', size: '', quantity: 1, totalPrice:0,unitPrice:0,unitPriceUsd:0,componentMasterId:'' });
  const {mutate: getPpeKitList, data: ppeList} = getPpeKit();
  const [itemOptions, setItemOptions] = useState([]);
  const [sizeOptions, setSizeOptions] = useState([]);
  const [selectedOption, setSelectedOption] = useState();
  const [adhocList, setAdhocList] = useState([]);

  useEffect(() => {
    if(restoredPpeCategoryDetails?.restoredPpeDetails?.length>0) {
      let data = restoredPpeCategoryDetails?.restoredPpeDetails?.filter((item) => item.isAdhoc);
      setAdhocList(restoredPpeCategoryDetails?.restoredPpeDetails?.length>0 ? [...data] : [...adhocList]);
    }
}, []);
useEffect(() => {
getAllPpeComponents()
}, []);
const getAllPpeComponents = async() =>
{
  const adhocDropDownData= await getAllPpeComponent(true);
  setItemOptions(adhocDropDownData.data.items);
}
  useEffect(() => {
    if (crew?.crewCode && crew?.expenseLineItemId,crew?.plannedVesselId) {
      getPpeKitList(crew); 
    } 
    if(oldCrew !== crew?.crewCode) {
      setppeListFinal([]);
    }
  }, [crew?.crewCode, crew?.expenseLineItemId,crew?.plannedVesselId]);
  useEffect(() => {
    if(!ppeList)
    {
      setppeListFinal([]);
      setFieldValue(`purchaseOrderCrew[${index}].ppeCategoryDetails`, []);
       return
    }
    if(oldCrew !== crew?.crewCode) {
      if (crew?.expenseLineItemId && ppeList?.status === 204) {
       setppeListFinal(adhocList);
       setFieldValue(`purchaseOrderCrew[${index}].ppeCategoryDetails`, ...adhocList);
       return
      }
    }
    if(restoredPpeCategoryDetails?.restoredPpeDetails?.length>0)
    {
      const dataNew = ppeList?.data?.ppeKitItems?.map((item) => ({
        componentName: item?.componentName,
        componentMasterId: item?.ppeComponentMasterId,
        componentId: item?.componentId,
        MasterId: ppeList?.data?.id,
        measurement: item?.measurement?.[0] || '',
        quantity: item?.quantity,
        isAdhoc: false,
        unitPrice:item?.unitPrice,
        unitPriceUsd:item?.unitPriceUsd,
        totalPrice: values?.currencyId === 1 ? item?.quantity * item?.unitPrice : item?.quantity * item?.unitPriceUsd
      }));
       if(restoredPpeCategoryDetails?.plannedVesselId == crew.plannedVesselId) {
        let mergedData = restoredPpeCategoryDetails?.restoredPpeDetails?.map(item => {
          let replacement = adhocList.find(adhocItem => adhocItem.componentName === item.componentName);
          return replacement ? replacement : item;
      }); 
      let val = [...mergedData, ...adhocList.filter(adhocItem => 
        !restoredPpeCategoryDetails?.restoredPpeDetails?.some(dataItem => dataItem.componentName === adhocItem.componentName)
    )];
        setppeListFinal(val);  
      } else {
       if (dataNew) {
        let val = [...dataNew, ...adhocList];
       setFieldValue(`purchaseOrderCrew[${index}].ppeCategoryDetails`, val);
       setppeListFinal(val)
       }
       else {
      let val = [...adhocList];
        setFieldValue(`purchaseOrderCrew[${index}].ppeCategoryDetails`, val);
        setppeListFinal(val)
       }
     }   
    } 
    else {
    if (crew?.ppeCategoryDetails?.length > 0) {
      setppeListFinal(crew?.ppeCategoryDetails);
    } else {
      const dataNew = ppeList?.data?.ppeKitItems?.map((item) => ({
        componentName: item?.componentName,
        componentMasterId: item?.ppeComponentMasterId,
        componentId: item?.componentId,
        MasterId: ppeList?.data?.id,
        measurement: item?.measurement?.[0] || '',
        quantity: item?.quantity,
        unitPrice:item?.unitPrice,
        unitPriceUsd:item?.unitPriceUsd,
        totalPrice: values?.currencyId === 1 ? item?.quantity * item?.unitPrice : item?.quantity * item?.unitPriceUsd
      }));
      if(dataNew) {
        setppeListFinal([...dataNew, ...adhocList])
      }
      else{
        setppeListFinal([...adhocList]) 
      }    
    }
  }
  }, [ppeList]);
  useEffect(() => {
    setFieldValue(`purchaseOrderCrew[${index}].ppeCategoryDetails`, ppeListFinal);
    if(crew?.expenseLineItemId && crew?.crewCode) {
      if (ppeListFinal.length > 0) {
      if(values?.currencyId === 1) {
      setColumns(['Item', 'Size', 'Quantity', 'Unit Price(INR)', 'Total Price(INR)'])
      const amount = ppeListFinal?.reduce((acc, item) => acc + item?.quantity * item?.unitPrice, 0).toFixed(2);
            setFieldValue(`purchaseOrderCrew[${index}].amount`, Number(amount).toFixed(2));    
      } else {
      setColumns(['Item', 'Size', 'Quantity', 'Unit Price(USD)', 'Total Price(USD)'])
        const amount = ppeListFinal?.reduce((acc, item) => acc + item?.quantity * item?.unitPriceUsd, 0).toFixed(2);
      setFieldValue(`purchaseOrderCrew[${index}].amount`, Number(amount).toFixed(2));    
      }
    } else {
      setFieldValue(`purchaseOrderCrew[${index}].amount`, '');
    }
    }
  }, [ppeListFinal, crew?.expenseLineItemId, values?.currencyId]);
  const category = expenseCategoryList?.find(({ expenseCategoryID }) => expenseCategoryID === id);
  const hanldeDelete = (item,index) => () => {
   let newPPEList= ppeListFinal?.filter((item) => item?.isAdhoc).filter((i,idx) => idx !== index);
   let newPPEListNonAdhoc=  values?.purchaseOrderCrew[0]?.ppeCategoryDetails?.filter((item) => !item?.isAdhoc);
    setppeListFinal([...newPPEList, ...newPPEListNonAdhoc]);
    setAdhocList(newPPEList)
  };
 const handleAddItem = () => {
  if (newItem.item && (!selectedOption?.sizable || newItem.size)  && newItem.quantity > 0) {
    const isDuplicate = ppeListFinal?.some(
      (ppe) => ppe.componentName === newItem.item
    );
    if (isDuplicate) {
      showAlert('Item already exists!', 'error');
      return;
    }
    const newPPE = {
      componentName: newItem.item,
      measurement: newItem.size,
      quantity: newItem.quantity,
      componentMasterId: newItem.componentMasterId,
      isAdhoc: true,
      totalPrice: values?.currencyId === 1 
        ? newItem.quantity * newItem.unitPrice 
        : newItem.quantity * newItem.unitPriceUsd,
      unitPrice: newItem.unitPrice,
      unitPriceUsd: newItem.unitPriceUsd,
    };
    setAdhocList([...adhocList, newPPE])
    setppeListFinal([...values?.purchaseOrderCrew[0]?.ppeCategoryDetails, newPPE]);
    setNewItem({ item: '', size: '', quantity: '' });
    setFieldValue('AdhocItem', '');
    setFieldValue('size', '');
    setFieldValue('quantity', '');
  } else {
    showAlert('Please fill all fields before adding!', 'error');
  }
};
  const handleInputChange = (field, value) => {
    setNewItem((prev) => ({ ...prev, [field]: value }));
  };
  const handleItemChange = (val) => {
    setFieldValue('size','')
    handleInputChange('item',val?.name)
    handleInputChange('componentMasterId',val?.id)
    handleInputChange('unitPrice',val?.unitPrice)
    handleInputChange('unitPriceUsd',val?.unitPriceUsd)
    const selectedItem = itemOptions.find(item => item.name === val?.name);
    setSelectedOption(selectedItem)
    if (selectedItem?.sizable) {
      setSizeOptions(selectedItem.measurement);
    } else {
      setSizeOptions([]);
    }
  };
  const isDisabled = crew?.isShortClosed
  || crew?.invoiceStatus?.toLowerCase().includes('payment')
  || crew?.invoiceStatus?.toLowerCase().includes('voucher')
  || crew?.invoiceStatus?.toLowerCase().includes('transferred');
  const isButtonDisabled = !ppeListFinal || isDisabled;
  return (
    <>
      {(crew?.crewCode && crew?.expenseLineItemId) && (
      <div className="capitalize pt-8 font-extrabold text-base">
        <div className="cursor-pointer flex justify-between bg-white-dark p-2 text-sm adhoc-item-color"  onClick={() => setShow(!show)}>
          {category?.categoryName} - Adhoc Item
          <span
            className={`rotatable ${show ? 'expanded' : 'collapsed'}`}
          >
            <IoMdArrowDropdown size={'25px'} color=''/>
          </span>
        </div>
        <hr />
      </div>
      )}
    {(crew?.crewCode && crew?.expenseLineItemId && show) && (
        <>
          <div className="flex-col justify-start items-start">
            <div>
            <>       
                      <div className="p-1 mb-4">
                      <div className="grid grid-cols-10 gap-6 p-1 relative">
  <div className="col-span-3">
    <Field
      name='AdhocItem'
      component={DropdownFieldComponent}
      className="w-full"
      setChangedValue={(val)=>handleItemChange(val)}
      onChange={()=>handleItemChange()}
      options={itemOptions.map(item => ({ label: item.name, value: item }))}
      id="adhocItem"
      requiredField
      isDisabled={isDisabled}
      rounded
      isClearable
      type="text"
      placeholder=""
      label="Item" />
  </div>
  <div className="col-span-3">
    <Field
      name='size'
      value={newItem.size}
      options={sizeOptions.map(size => ({ label: size, value: size }))}
      setChangedValue={(val)=>handleInputChange('size', val)}
      component={DropdownFieldComponent}
      className="w-full"
      isClearable
      isDisabled={isDisabled}
      requiredField={selectedOption?.sizable ? true : false}
      rounded
      type="text"
      placeholder=""
      label="Size" />
  </div>
  <div className="col-span-3">
                 <Field
                  name="quantity"
                  component={InputFieldComponent}
                  setChangedValue={(val)=>handleInputChange('quantity', val)}
                  className="w-full"
                  requiredField
                  disabled={isDisabled}
                  min={1}
                  onInput={(e) => {
                    handleInputChange('quantity', e.target.value)
                  }}
                  size="large"
                  rounded
                  id="quantity"
                  type="number"
                  onWheel={(e) => e.target.blur()}
                  label="Quantity"
                />
  </div>
  <div className="flex justify-end items-center">
    <button
        type="button"
        className="adhoc-add-btn w-10 h-10 rounded-full flex items-center justify-center disabled:opacity-50"
        disabled={isButtonDisabled}
        onClick={handleAddItem}
     >
      <span className="text-2xl">+</span>
    </button>
  </div>
</div>                               
                      </div>               
                    </>
            </div>
          </div>
  {ppeListFinal
          ?.filter((item) => item?.isAdhoc)?.length > 0 && (
<AdhocItemTable
  ppeListFinal={ppeListFinal}
  crew={crew}
  values={values}
  setAdhocList={setAdhocList}
  errors={errors}
  touched={touched}
  itemOptions={itemOptions}
  setppeListFinal={setppeListFinal}
  setFieldValue={setFieldValue}
  index={index}
  hanldeDelete={hanldeDelete}
  columns={columns}
/>
)}
        </>
      )}
    </>
  );
};

export default AdhocItemForm;
